import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ReactComponent as TrashCanIcon } from "../../../../images/trash-can.svg";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { removeUserFromCompany } from "services";
import { CustomButton } from "ui";

export const RemoveCompanyFromUserButton = observer(({ companyId }: { companyId: string }) => {
  const { actionModals, userCard, userCompanyList } = useStores();

  const removeCompanyFromUserHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы уверены, что хотите отключить пользователя от выбранной компании?"
          successText="Пользователь отключен от компании"
          buttonText="Отключить"
          calledQuery={() => removeUserFromCompany({ id: companyId, userId: userCard.card.id })}
          onSuccess={() => {
            setTimeout(() => {
              userCompanyList.fetch();
            }, 1000);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton
      type="link"
      size="small"
      icon={<TrashCanIcon />}
      onClick={removeCompanyFromUserHandler}
      tooltip="Отключить компанию"
    />
  );
});
